import { Backdrop } from '../primitives/backdrop.js'
import type { FC } from 'react'
import Pulse from './pulse.js'

export interface FullPageProgressProps {
  show?: boolean
}

export const FullPageProgress: FC<FullPageProgressProps> = props => {
  const { show = true } = props

  return (
    <Backdrop
      open={show}
      style={{
        display: show ? 'flex' : 'none',
        backgroundColor: 'var(--tuna-palette-layers)',
        zIndex: 'var(--tuna-zIndex-drawer)' as never,
      }}
    >
      <Pulse size="large" />
    </Backdrop>
  )
}

export default FullPageProgress
